import React from 'react';

import { ToolCard } from './link_card';

import type { CardTheme } from './card_theme';
import type { IndexCardMetadata } from '../types';

interface IndexCardToolCall {
  metadata: { index?: IndexCardMetadata; records?: unknown[] };
}

export function getIndexCards(toolCalls: IndexCardToolCall[]) {
  const byPath = new Map<string, IndexCardMetadata>();
  toolCalls.forEach(({ metadata }) => {
    if (metadata.index) byPath.set(metadata.index.path, metadata.index);
  });

  return [...byPath.values()];
}

interface IndexCardProps {
  index: IndexCardMetadata;
  label: string;
  pageName: string;
  theme: CardTheme;
}

export function IndexCard({ index, label, pageName, theme }: IndexCardProps) {
  return (
    <ToolCard href={index.path} theme={theme}>
      <div className="fw-semibold text-truncate">{`Found ${index.totalCount} ${label}`}</div>
      <div className="small text-muted text-truncate">View on the {pageName} page</div>
    </ToolCard>
  );
}
